import React from 'react';
import { Loader2 } from 'lucide-react';
import MotorPlanLogo from '@/shared/components/MotorPlanLogo';

interface AppLoaderProps {
    /** Optional message shown beneath the spinner. Defaults to "Loading your workspace…". */
    message?: string;
    /** Optional retry/error CTA region. When provided, the spinner is hidden and this is rendered below the logo. */
    errorAction?: React.ReactNode;
}

/**
 * Full-viewport branded loader. Used as the splash for AuthProvider startup,
 * the ProtectedRoutes first-login window, and any future "app-not-ready" gate.
 */
export const AppLoader: React.FC<AppLoaderProps> = ({
    message = 'Loading your workspace…',
    errorAction,
}) => (
    <div
        className="fixed inset-0 z-[60] flex flex-col items-center justify-center bg-mp-surface"
        data-testid="app-loader"
    >
        <MotorPlanLogo textSize="h-8" iconSize="h-8" />
        {errorAction ? (
            <div className="mt-8 flex flex-col items-center" data-testid="app-loader-error">
                {errorAction}
            </div>
        ) : (
            <>
                <Loader2
                    className="w-8 h-8 mt-8 text-mp-primary animate-spin"
                    aria-hidden="true"
                    data-testid="app-loader-spinner"
                />
                <p
                    className="mt-4 text-sm text-mp-muted"
                    role="status"
                    aria-live="polite"
                >
                    {message}
                </p>
            </>
        )}
    </div>
);
